import request from '../utils/Request';
import { Methods } from '../config';
import { downloadFile } from '../utils/download';

const baseURL = 'formPrintTemplate';

const formPrintTemplateService = {
  getTemplates: () => {
    return request({
      resource: `${baseURL}/`,
    });
  },
  uploadFile: (file, id, userId) => {
    const formData = new FormData();
    formData.append('files', file);
    formData.append('userId', userId);

    return request({
      method: Methods.POST,
      resource: `${baseURL}/uploadFile/${encodeURIComponent(id)}`,
      formData: true,
      data: formData,
    });
  },

  deleteFile: (id, userId) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/deleteFile/${encodeURIComponent(id)}`,
      data: { userId },
    });
  },

  getFile: async (id, fileName) => {
    const file = await request({
      responseType: 'blob',
      resource: `${baseURL}/getFile/${encodeURIComponent(id)}`,
    });
    return downloadFile(file, fileName);
  },
};

export default formPrintTemplateService;
